require('./search_fetcher')
# TODO: WEBPACKER - export search_fetcher then import

SearchFetcher = LP.module('Searches').SearchFetcher

class SearchContext
  constructor: (options = {}) ->
    @dispatcher       = new FluxDispatcher
    @fetcher          = new SearchFetcher options
    @actionContext    = @getActionContext()
    @componentContext = @getComponentContext()

  @registerStore: FluxDispatcher.registerStore.bind(FluxDispatcher)

  getComponentContext: ->
    executeAction: @executeAction
    getStore:      @getStore
    hasStore:      @hasStore

  getActionContext: ->
    executeAction: @executeAction
    dispatch:      @dispatcher.dispatch.bind(@dispatcher)
    fetcher:       @fetcher
    getStore:      @getStore

  getStore: (store) =>
    @dispatcher.getStore store

  hasStore: (store) =>
    !!@dispatcher.storeInstances[store]

  executeAction: (actionController, payload, successCallback) =>
    actionController @actionContext, payload, successCallback

LP.module('Searches').SearchContext = SearchContext
